import { useTranslation } from "next-i18next";
import { useAppSelector } from "@/store/hooks";
import { useSiteInfo } from "@/hooks/useSiteInfo";
import Languages from "./Languages";

/**
 * 语言环境
 */
const Locale = () => {
  const { t } = useTranslation();
  const token = useAppSelector((state) => state.user.token);
  const siteInfo = useSiteInfo();

  // 未登录且不在配送区域时，展示区域受限提示
  const showRegionTip = !token && siteInfo?.isInPostArea === false;

  return (
    <div className="hidden h-34px w-full justify-center bg-stone-800 lg:flex ">
      <div className="flex h-full w-full items-center justify-between lg:w-md-container xl:w-container">
        <div className="text-sm text-white">{showRegionTip ? t("common.region_limited_tip") : ""}</div>
        <Languages />
      </div>
    </div>
  );
};

export default Locale;
